import type { MatrixMatch, PlayerMatrixSortPayload } from '@/services/quizzes';
import styles from './QuizQuestion.module.scss';

interface MatrixSortQuestionProps {
  payload: PlayerMatrixSortPayload;
  value: MatrixMatch[];
  onChange: (matches: MatrixMatch[]) => void;
  disabled?: boolean;
  reveal?: boolean;
}

// Cada item de la columna izquierda muestra un <select> con las opciones de la derecha.
export function MatrixSortQuestion({ payload, value, onChange, disabled, reveal }: MatrixSortQuestionProps) {
  const selectedFor = (leftId: string): string => value.find((m) => m.left_id === leftId)?.right_id ?? '';
  const correctMap = new Map((payload.matches ?? []).map((m) => [m.left_id, m.right_id]));

  function setMatch(leftId: string, rightId: string) {
    if (disabled) return;
    const filtered = value.filter((m) => m.left_id !== leftId);
    if (rightId) filtered.push({ left_id: leftId, right_id: rightId });
    onChange(filtered);
  }

  return (
    <div className={styles.matrix}>
      {payload.left.map((leftItem) => {
        const submitted = selectedFor(leftItem.id);
        const correctRightId = correctMap.get(leftItem.id);
        let rowExtra = '';
        if (reveal && correctRightId !== undefined) {
          rowExtra = submitted === correctRightId ? styles.optionCorrect ?? '' : styles.optionIncorrect ?? '';
        }
        return (
          <div key={leftItem.id} className={`${styles.matrixRow} ${rowExtra}`}>
            <span className={styles.matrixLeft}>{leftItem.text}</span>
            <select
              className={styles.matrixSelect}
              value={submitted}
              onChange={(e) => setMatch(leftItem.id, e.target.value)}
              disabled={disabled}
            >
              <option value="">— elige —</option>
              {payload.right.map((r) => (
                <option key={r.id} value={r.id}>{r.text}</option>
              ))}
            </select>
          </div>
        );
      })}
    </div>
  );
}
